var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1428 22.9799C13.5575 23.3951 13.557 24.0679 13.1418 24.4825C12.7266 24.8972 12.0539 24.8967 11.6392 24.4815L4.56069 17.3933C4.14627 16.9783 4.14646 16.306 4.56112 15.8913L11.6397 8.81128C12.0545 8.3963 12.7273 8.39623 13.1423 8.81112C13.5572 9.22601 13.5573 9.89875 13.1424 10.3137L7.87242 15.5833H18.9816C21.2409 15.5833 22.964 15.9261 24.4911 16.6663L24.8402 16.8442C26.4105 17.6841 27.6493 18.9228 28.4891 20.4932C29.3524 22.1075 29.75 23.9186 29.75 26.3517C29.75 26.9385 29.2743 27.4142 28.6875 27.4142C28.1007 27.4142 27.625 26.9385 27.625 26.3517C27.625 24.2496 27.3025 22.7803 26.6153 21.4953C25.9735 20.2953 25.038 19.3599 23.838 18.7181C22.6519 18.0837 21.3087 17.7601 19.4557 17.7141L18.9816 17.7083H7.8795L13.1428 22.9799Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.de4af55de1e43e9bff89663d780ba538.svg";
export { ForwardRef as ReactComponent };